import Init from '../containers/Init'
import dashboard from './dashboard'
import events from './events'
import banners from './banners'
import settings from './settings'

export default [
  {
    key: 'view_root',
    url: '/',
    name: 'App',
    title: 'LOOPI',
    component: Init,
  },
  {
    key: 'view_forgot_password',
    url: '/forgot-password',
    name: 'forgotPassword',
    title: 'Olvidé mi contraseña',
    component: Init,
  },
  {
    key: 'view_register',
    url: '/register',
    name: 'register',
    title: 'Registrarme',
    component: Init,
  },
  ...dashboard,
  ...events,
  ...banners,
  ...settings,
]
